





import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

@Component
export default class Public extends Vue {
  @Getter('locale', { namespace: 'user' }) locale: string
  @Action('setUserLocale', { namespace: 'user' }) setUserLocale

  mounted() {
    if (!this.locale) {
      const locale = navigator.language.split('-')[0]
      this.setUserLocale(locale)
    }
  }
}
